var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1ED760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7C12.8205 7 7 12.8199 7 20C7 27.1801 12.8205 33 20 33C27.1795 33 33 27.1801 33 20C33 12.8199 27.1795 7 20 7ZM26.3424 25.7403C26.1336 26.11 25.7496 26.318 25.3536 26.318C25.1685 26.318 24.9774 26.2717 24.8021 26.1742C23.1791 25.2642 21.4103 24.7068 19.5411 24.5175C17.6679 24.3298 15.8183 24.5199 14.0417 25.0871C13.4488 25.2764 12.8106 24.9489 12.6215 24.355C12.4305 23.7602 12.7594 23.1241 13.3542 22.9339C15.4264 22.2718 17.5871 22.0467 19.7695 22.2685C21.948 22.4903 24.0123 23.1403 25.9071 24.2024C26.4527 24.5061 26.6477 25.1951 26.3424 25.7403ZM27.8985 21.7916C27.6976 22.1783 27.3036 22.4001 26.8959 22.4001C26.7186 22.4001 26.5414 22.3595 26.3739 22.2718C24.3786 21.2326 22.2238 20.5891 19.9645 20.3599C17.6876 20.1268 15.4323 20.3299 13.2577 20.9571C12.657 21.1277 12.0306 20.7841 11.8593 20.1836C11.6859 19.584 12.0326 18.9576 12.6314 18.7845C15.0856 18.0768 17.6305 17.8501 20.193 18.1101C22.7379 18.3693 25.1685 19.0941 27.4199 20.2673C27.9714 20.5558 28.188 21.2382 27.8985 21.7916ZM28.4618 18.5066C28.2924 18.5066 28.1211 18.4684 27.9576 18.388C25.59 17.2074 23.0432 16.4721 20.3861 16.2024C17.725 15.9302 15.0777 16.1406 12.5152 16.8249C11.9124 16.9848 11.2939 16.6273 11.1324 16.0236C10.9709 15.4207 11.3294 14.8008 11.9341 14.6399C14.7606 13.8851 17.6836 13.6552 20.6165 13.9534C23.5455 14.2499 26.3542 15.0616 28.9661 16.3641C29.5255 16.6427 29.752 17.322 29.4742 17.8802C29.2773 18.2775 28.8774 18.5066 28.4618 18.5066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/Spotify.a608f401e00ccb72dd0f478047ecd2d7.svg";
export { ForwardRef as ReactComponent };